import { StyledHeader } from "./styled";

const Header = ({ title }) => (
    <StyledHeader>
        {title}
    </StyledHeader>
);

export default Header;